import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useMemo } from 'react';
import { Grid, NativeSelect } from '@vitessce/styles';
import { isEqual } from 'lodash-es';
export function BiomarkerSelectAltSampleGroups(props) {
    const { setSampleSetFilter, setSampleSetSelection, stratifications, } = props;
    const [lhsSelectedGroup, setLhsSelectedGroup] = useState(null);
    const [rhsSelectedGroup, setRhsSelectedGroup] = useState(null);
    const sampleSetOptions = stratifications?.filter(s => s.stratificationType === 'sampleSet');
    const hasSampleSetOptions = sampleSetOptions && sampleSetOptions.length > 0;
    const lhsOptions = useMemo(() => {
        if (sampleSetOptions) {
            const result = [];
            const withDuplicates = sampleSetOptions.map(o => o.sampleSets).flat();
            withDuplicates.forEach((setPath) => {
                if (!result.find(r => isEqual(r.path, setPath))) {
                    const rhsOptionsForLhs = [];
                    sampleSetOptions.forEach((o) => {
                        const pathPair = o.sampleSets;
                        if (isEqual(pathPair[0], setPath)) {
                            const otherPath = pathPair[1];
                            rhsOptionsForLhs.push({
                                name: `${otherPath[0]}: ${otherPath[1]}`,
                                path: otherPath,
                                sampleSets: o.sampleSets,
                                stratificationId: o.stratificationId,
                            });
                        }
                        else if (isEqual(pathPair[1], setPath)) {
                            const otherPath = pathPair[0];
                            rhsOptionsForLhs.push({
                                name: `${otherPath[0]}: ${otherPath[1]}`,
                                path: otherPath,
                                // Reverse the order.
                                sampleSets: [o.sampleSets[1], o.sampleSets[0]],
                                stratificationId: o.stratificationId,
                            });
                        }
                    });
                    result.push({
                        name: `${setPath[0]}: ${setPath[1]}`,
                        path: setPath,
                        rhsOptions: rhsOptionsForLhs,
                    });
                }
            });
            return result;
        }
        return [];
    }, [sampleSetOptions]);
    const rhsOptions = useMemo(() => {
        if (sampleSetOptions && lhsOptions && lhsSelectedGroup) {
            const lhsOption = lhsOptions.find(o => o.name === lhsSelectedGroup);
            return lhsOption ? lhsOption.rhsOptions : [];
        }
        return [];
    }, [sampleSetOptions, lhsOptions, lhsSelectedGroup]);
    function handleFirstGroupChange(event) {
        setLhsSelectedGroup(event.target.value);
        // Update the sampleSetFilter and sampleSetSelection.
        if (event.target.value === '__all__') {
            setSampleSetFilter(null);
            setSampleSetSelection(null);
        }
        else {
            const lhsOption = lhsOptions.find(o => o.name === event.target.value);
            if (lhsOption) {
                setSampleSetFilter([lhsOption.path]);
                setSampleSetSelection([lhsOption.path]);
            }
        }
    }
    function handleSecondGroupChange(event) {
        setRhsSelectedGroup(event.target.value);
        // Update the sampleSetFilter and sampleSetSelection.
        if (event.target.value === '__none__') {
            const lhsOption = lhsOptions.find(o => o.name === lhsSelectedGroup);
            if (lhsOption) {
                setSampleSetFilter([lhsOption.path]);
                setSampleSetSelection([lhsOption.path]);
            }
        }
        else {
            const rhsOption = rhsOptions.find(o => o.name === event.target.value);
            if (rhsOption) {
                setSampleSetFilter(rhsOption.sampleSets);
                setSampleSetSelection(rhsOption.sampleSets);
            }
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, size: 12, children: [_jsx(Grid, { container: true, size: 4, children: _jsx("span", { style: { lineHeight: '50px' }, children: "in:\u00A0" }) }), _jsx(Grid, { container: true, size: 8, children: _jsxs(NativeSelect, { onChange: handleFirstGroupChange, value: lhsSelectedGroup ?? '__all__', variant: "standard", sx: { width: '100%' }, children: [_jsx("option", { value: "__all__", children: "All" }), hasSampleSetOptions ? (_jsx(_Fragment, { children: lhsOptions.map(o => (_jsx("option", { value: o.name, children: o.name }))) })) : null] }) })] }), _jsxs(Grid, { container: true, size: 12, children: [_jsx(Grid, { container: true, size: 4, children: _jsx("span", { style: { lineHeight: '50px' }, children: "compare to:\u00A0" }) }), _jsx(Grid, { container: true, size: 8, children: _jsxs(NativeSelect, { onChange: handleSecondGroupChange, value: rhsSelectedGroup ?? '__none__', variant: "standard", sx: { width: '100%' }, children: [_jsx("option", { value: "__none__", children: "None" }), hasSampleSetOptions ? (_jsx(_Fragment, { children: rhsOptions.map(o => (_jsx("option", { value: o.name, children: o.name }))) })) : null] }) })] })] }));
}
//# sourceMappingURL=BiomarkerSelectAltSampleGroups.js.map